import { IconsProps, ThemeUnion } from '@almbrand/systemicons/dist/cjs/types/icon';
import { SearchFieldOption } from 'components/2-molecules/SearchFieldComponent/SearchFieldComponent';
import { Page } from 'context/PageContext';
import { apiInstanceCached } from '../services/Api';
import { SearchComponent, SearchConfiguration } from './SearchConfiguration';

type SpdSearchResponse = {
	data: {
		URL?: string;
		name?: string;
		response?: {
			default?: boolean;
			label?: string;
			value?: string;
		}[];
	};
};

export class SpdSearch implements SearchComponent {
	searchConfiguration: SearchConfiguration;
	apiSearch: boolean;
	searchIcon: IconsProps<ThemeUnion>['icon'];
	pageContext: Partial<Page>;
	spdBody?: any;

	constructor(searchConfiguration: SearchConfiguration, pageContext: Partial<Page>, spdBody?: any) {
		this.searchConfiguration = searchConfiguration;
		this.apiSearch = false;
		this.pageContext = pageContext;
		this.spdBody = spdBody;
	}

	init = async (): Promise<SearchFieldOption[]> => {
		const url =
			this.searchConfiguration.url ||
			this.pageContext?.metaArea?.items?.[0]?.content?.quoteSearchConfigurationApiEndpoint?.url ||
			'';

		if (!url) {
			console.error('No URL defined for SPD search.');
			return [];
		}

		const method = this.searchConfiguration.httpMethod || 'GET';

		const options: SearchFieldOption[] = [];

		try {
			const res: SpdSearchResponse = await apiInstanceCached()[method.toLowerCase()](url, {
				name: this.searchConfiguration.spdSearchConfigurationName,
				params: this.searchConfiguration.inputFields.items.map((item, index) => ({
					param_name: item.content.param || '',
					param_value:
						this.pageContext?.metaArea?.items[0]?.content?.staticFields?.items[index]?.content
							?.defaultValue || '',
				})),
			});

			res?.data?.response?.forEach((element) => {
				options.push({
					label: element.label,
					value: element.value,
				});
			});

			return options.sort((a, b) => a.label.localeCompare(b.label));
		} catch (error) {
			console.error('Error during SPD search:', error);
			return [];
		}
	};
}
